export default __webpack_public_path__ + "static/media/olho.af412db1.svg";